import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { LessonSong } from '../../../models/lesson-song'
import { LessonSongCssService } from '../lesson-song-css.service'
import { MenuPopoverComponent } from '../../../components/menu-popover/menu-popover.component'
import { PopoverController } from '@ionic/angular'
import { LessonPrefs, PreferencesProvider } from '../../../providers/preferences/preferences.provider'
import { Resources } from '../../../models/resources'
import { Teacher } from '../../../models/teacher'
import { CssUtilitiesService } from '../../../services/css/css-utilities.service'
import { Course } from 'src/app/models/course';
import { Lesson } from 'src/app/models/lesson';
import { ClassType } from 'src/app/models/class-type';
import { StaticDataService } from 'src/app/services/static-data.service';
import { text } from 'stream/consumers';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: '[app-lesson-song]',
  templateUrl: './lesson-song.component.html',
  styleUrls: ['./lesson-song.component.scss']
})
export class LessonSongComponent implements OnInit {

  @ViewChild('textAreaActivity') textAreaActivity: ElementRef;

  @Input() song: LessonSong
  @Input() index: number
  @Input() isEditing: boolean

  _resources: Resources = Resources.defaults()
  get resources(): Resources { return this._resources }
  @Input() set resources(resources: Resources) { this._resources = resources ||  Resources.defaults() }

  _teacher: Teacher = Teacher.defaults()
  get teacher(): Teacher { return this._teacher }
  @Input() set teacher(teacher: Teacher) { this._teacher = teacher ||  Teacher.defaults() }

  _course: Course = Course.defaults()
  @Input() set course(course: Course) { this._course = course }

  _lesson: Lesson = Lesson.defaults()
  @Input() set lesson(lesson: Lesson) { this._lesson = lesson }

  @Output() addSong = new EventEmitter<number>();
  @Output() togglePem = new EventEmitter<LessonSong>()
  @Output() playRecording = new EventEmitter<LessonSong>()
  @Output() showSongInfo = new EventEmitter<LessonSong>()
  @Output() autoSave = new EventEmitter<LessonSong>()

  lessonPrefs: LessonPrefs

  nameColumnWidth: number
  tonalityColumnWidth: number
  meterColumnWidth: number
  swowColumnWidth: number
  activityColumnWidth: number
  rpColumnWidth: number
  tpColumnWidth: number
  instrumentColumnWidth: number
  recordingColumnWidth: number
  pemColumnWidth: number
  infoColumnWidth: number
  isActivityEditable: boolean = false;


  get placeholder(): string {
    return this.activityDefaultText()
    // return this.isActivityEditable ? '' : this.activityDefaultText()
  }

  private _lastActivityText: string
  get activityText(): string {
    return this.isActivityEditable ? this._lastActivityText : this.song.activity
  }
  set activityText(value: string) { this._lastActivityText = value }

  constructor(
    private preferencesProvider: PreferencesProvider,
    public lessonSongCssService: LessonSongCssService,
    public cssUtilitiesService: CssUtilitiesService,
    private staticDataService: StaticDataService) {

      this.lessonPrefs = this.preferencesProvider.getLessonPrefs();
      // this._lastActivityText = this.song.activity
  }
  @HostListener('focusout', ['$event'])
  onFocusout() {
   this.isActivityEditable = false;
  }

  updateColumnWidths() {
    // subtract 1 from elements that will have border in td element
    this.nameColumnWidth = this.lessonSongCssService.columnWidth('name')
    this.tonalityColumnWidth = this.lessonSongCssService.columnWidth('tonality') - 1
    this.meterColumnWidth = this.lessonSongCssService.columnWidth('meter') - 1
    this.swowColumnWidth = this.lessonSongCssService.columnWidth('swow') - 1
    this.activityColumnWidth = this.lessonSongCssService.columnWidth('activity') - 1
    this.rpColumnWidth = this.lessonSongCssService.columnWidth('rp') - 1
    this.tpColumnWidth = this.lessonSongCssService.columnWidth('tp') - 1
    this.instrumentColumnWidth = this.lessonSongCssService.columnWidth('instrument') - 1
    this.recordingColumnWidth = this.lessonSongCssService.columnWidth('recording') - 1
    this.pemColumnWidth = this.lessonSongCssService.columnWidth('pem') - 1
    this.infoColumnWidth = this.lessonSongCssService.columnWidth('info') - 1
  }

  ngOnInit() {
    this.lessonSongCssService.widthChanged.subscribe(value => {
      this.updateColumnWidths()
    })
    this.isEditing = true;
  }

  onScroll(event: Event) {
    window.document.querySelectorAll('section.details').forEach((el: Element) => {
      if (el !== event.target) {  // setting the element's own scrollLeft makes scrolling jerky on iOS
        el.scrollLeft = event.target['scrollLeft']
      }
    })
  }

  getRootClasses(): string[] {
    const classes = ['song', this.lessonSongCssService.responsiveClass()]
    if (this.isEditing) {
      classes.push('editing')
    }
    if (this.song && this.song.name && this.song.name.length > 0) {
      classes.push('assigned')
    } else {
      classes.push('empty')
    }
    return classes
  }

  isLessonSongExpanded() {
    return this.preferencesProvider.isLessonSongExpanded(this.song)
  }

  toggleLessonSongExpanded() {
    this.preferencesProvider.setLessonSongExpanded(this.song, !this.preferencesProvider.isLessonSongExpanded(this.song))
  }

  activityChanged() {  // is done on lessonBeingEdited
    // if (this._lastActivityText.length == 0) return;
    this.song.isDirty = true
    this.isActivityEditable = false
    this.song.activity = this._lastActivityText
    this.autoSave.emit(this.song)
    // this.teacherProvider.saveTeacher()
  }

  toggleRP() {  // is done on lessonBeingEdited
    this.song.hasRp = !this.song.hasRp
    this.song.hasTp = this.song.hasRp ? false : this.song.hasTp
    this.song.isDirty = true
    this.autoSave.emit(this.song)
    // this.teacherProvider.saveTeacher()
  }

  toggleTP() {  // is done on lessonBeingEdited
    this.song.hasTp = !this.song.hasTp
    this.song.hasRp = this.song.hasTp ? false : this.song.hasRp
    this.song.isDirty = true
    // this.teacherProvider.saveTeacher()
    this.autoSave.emit(this.song)
  }

  toggleInstrument() {  // is done on lessonBeingEdited
    this.song.hasInstrument = !this.song.hasInstrument
    this.song.isDirty = true
    // this.teacherProvider.saveTeacher()
    this.autoSave.emit(this.song)
  }

  chooseRecording() {  // is done on lessonBeingEdited

      /* Removed popup, it will work like a toggle button */
      const recordingType: LessonSong.RecordingType = this.recordingType()
    this.setRecordingType(recordingType)

    // const customTypes = [{name: 'Custom', action: () => { this.setRecordingType(LessonSong.RecordingType.Custom) }}]
    // const mtTypes = [{name: '', action: () => { this.setRecordingType(LessonSong.RecordingType.Original) }}]
    // if (!Common.isNullOrUndefined(this.song.karaokeUrl)) {
    //   mtTypes.push({name: 'Karaoke', action: () => { this.setRecordingType(LessonSong.RecordingType.Karaoke) }})
    // }
    // MenuPopoverComponent.present(this.popoverCtrl, 'lesson-plans-popover', event, [
    //   ...(this.song.isCustom ?  customTypes : mtTypes),
    //   {name: 'None', hidden: this.song.recordingType === LessonSong.RecordingType.None, action: () => { this.setRecordingType(LessonSong.RecordingType.None) }},
    // ])
  }

  private setRecordingType(recordingType: LessonSong.RecordingType) {  // is done on lessonBeingEdited
    this.song.recordingType = recordingType
    this.song.isDirty = true
    this.autoSave.emit(this.song)
  }

  recordingType(): LessonSong.RecordingType {
    if(this.song.songUuid){
      return this.song.recordingType
      ? LessonSong.RecordingType.None
      : LessonSong.RecordingType.Original;
    }
    else{
      return this.song.recordingType
      ? LessonSong.RecordingType.None
      : LessonSong.RecordingType.Custom;
    }

  }

  pemButtonTitle(): string {
    if (!this.resources) { return ''}

    let pemName = ''
    if (this.song.pemUuid) {
      let pem = this.resources.findPem(this.song.pemUuid)
      if (!pem) {
        pem = this.teacher.findCustomPem(this.song.pemUuid)
      }
      if (pem) {
        pemName = pem.name || ''
      }
    }

    if (this.isEditing) {
      return !this.song.pemUuid ? `Add ${this.pemName}` : pemName
    } else {
      return !this.song.pemUuid ? '' : pemName
    }
  }

  onChangeActivity(e) {
    if (!this.isActivityEditable) {
      this._lastActivityText = this.song.activity
    }
    this.isActivityEditable = true
  }

  activityDefaultText(): string {
    return this.staticDataService.getActivityDefaultText(this.index+1, this._lesson, this._course);
  }

  get pemName(): string {
    if (this._course.classType === Course.ClassType.InSchool) {
      return 'TEM'
    } else if (this.isRhythmKids) {
      return 'GEM';
    } else {
      return 'PEM'
    }
  }

  get isRhythmKids(): boolean {
    return this._course.classType === Course.ClassType.RhythmKidsLevel1 || this._course.classType === Course.ClassType.RhythmKidsLevel2 || this._course.classType == Course.ClassType.RhythmKids
  }

  get isSongCustom(){
    if(this.recordingType() === LessonSong.RecordingType.Custom){
      return true
    }
    return false
  }

}
